module.exports = __webpack_public_path__ + "static/media/p4_8.e2e0d65b.png";